import * as API from '../constants/API';
import * as AWS from '../constants/AWS';
import axios from 'axios';

export class DayCareApi {
  constructor() {
    this.api = null;
  }

  set Api(api) {
    this.api = api;
  }

  get Api() {
    return this.api;
  }
}

const userPool = AWS.userPool();
const cognitoUser = userPool.getCurrentUser();

const getApi = () => {
  let api = null;
  if (cognitoUser === null) {
     return null;
  }

  cognitoUser.getSession((err, session) => {
    if (err) {
      return null;
    }

    if (session) {
      api = axios.create({
        baseURL: API.daycareApiRoot,
        headers: {
          'Authorization': session.getIdToken().getJwtToken()
        }
      });
    }
  });

  return api;
}

const instance = new DayCareApi();
instance.Api = getApi();

Object.freeze(instance);

export default instance;



// WEBPACK FOOTER //
// ./src/api/BaseAPI.js